import { BaseComponent } from '../../../../../../../components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { HBox, VBox } from '../../../../../../../components/Box';
import { Dropdown } from '../../../../../../../components/Dropdown';
import { InvoicePaymentConditionModal } from '../../../../../../Invoices/components/InvoicePaymentConditionModal';
import { ChangeLocationModal } from '../../../../ChangeLocationModal';
import { VehicleCreateOrderField } from './Fields';
import { fetchUser } from '../../../../../../Users/actions';
import { fetchCompany } from '../../../../../../Companies/actions';
import {
  initiateNewOrderValue,
  setNewOrderValue,
  addVehicleToOutgoingOrder,
  getTradeInVehiclesList,
} from '../../../../../actions';
import { selectUserId, selectWork, selectWorks } from '../../../../../../Api/selectors';
import { selectNewOrder, selectVehicles } from '../../../../../selectors';
import { BORDER_GREY_LIGHT } from '../../../../../../../vars';
import {
  DEFAULT_VAT_CODE,
  INVOICE_DIRECTIONS,
  INVOICE_SUBJECT_TYPES,
  OutgoingCostTypes,
  REQUEST_AMOUNTS_CALCULATIONS,
} from '../../../../../../Invoices/constants';
import { getPropByName } from '../../../../../../../utils/props';
import { fetchCompanyProductsIds, fetchProducts } from '../../../../../../products/actions';
import { selectProducts } from '../../../../../../products/selectors';
import { REQUEST_COMPANY_PRODUCTS_IDS, PRODUCT_STATUS, REQUEST_PRODUCTS } from '../../../../../../products/constants';
import { Loader } from '../../../../../../../components/Loader';
import { REQUEST_VEHICLES } from '../../../../../constants';
import { CircleTimes, Times } from '../../../../../../../components/Icon';
import { VehicleCreateModals } from '../../../../../pages/create/AddVehicleModals';
import { SearchSelect } from '../../../../../../../components/SearchSelectComponent';
import _ from 'lodash';
import cn from 'classnames';

import ModalComponent from '../../../../../../../containers/App/Components/Modal/Modal';
import ButtonComponent from '../../../../../../../containers/App/Components/Button/Button';
import CheckboxComponent from '../../../../../../../containers/App/Components/Checkbox/Checkbox';
import styles from './OutgoingOrderModal.module.css';
import { makeSelectLocale } from '../../../../../../../containers/LanguageProvider/selectors';
import { translateCountry } from '../../../../../../Companies/translate-countries';
import { EditableSearchSelect } from '../../../../../../../components/EditableSearchSelect';
import { OutgoingOrderVehicleCard } from '../../OutgoingOrderVehicleCard/OutgoingOrderVehicleCard';
import LoadingField from '../../../../../../../containers/App/Components/LoadingField/LoadingField';
import { calculateFinancialAmounts } from '../../../../../../Invoices/actions';
import { ProductDefaultTasksModalConfirmation } from '../../../../../../products/components/productDefaultTasksModal';
import { formatToTwoDecimalPlaces, limitToTwoDecimalPlaces } from '../../../../../../../utils/number';
import { applyTransportOrderFilters, updateTransportOrderFilter } from '../../../../../../TransportOrders/actions';
import { fixPriceFormat } from '../../../../../../../utils/string';
import { OutgoingOrderTradeInCard } from '../../OutgoingOrderTradeInCard';

const STATE = {
  inclMainProd: true,
  showLocationChange: false,
  showDeliveryLocationChange: false,
  sellWithLicensePlate: false,
  reqFieldMessage: null,
  closeModal: false,
  selectedTradeInVehicles: [],
  tradeInVehicleValue: null,
  disableSave: false,
};

const Container = styled.div`
  font-size: 14px;

  .cell:first-child {
    text-transform: capitalize;
  }

  input {
    -webkit-appearance: none;
    margin: 0;
  }

  .label {
    display: flex;
  }

  .small-input {
    min-width: 115px;
  }

  .address-block {
    border: 1px solid ${BORDER_GREY_LIGHT};
    padding: 5px;
  }

  .selection-block {
    margin-bottom: 12px;
  }

  .req-field-message {
    color: red;
  }

  .medium-dropdown {
    width: 450px;
    @media (min-width: 800px) and (max-width: 1200px) {
      width: 220px;
    }
  }
`;

const Address = styled.div`
  border: ${props => (!!props.isActive ? '1px solid rgb(21, 172, 121)' : '1px solid grey')};
  border-radius: 6px;
  padding: 12px;
  width: calc(33% - 10px);
  min-height: ${props => props.unknown && '118px'};
  background-color: ${props => props.unknown && 'red'};
  margin: 6px 0;
  font-size: 12px;

  @media (max-width: 768px) {
    width: 100%;
  }

  .button {
    margin: 0 -12px;
  }
  .name {
    font-size: 12px;
  }
  .address {
    margin-top: 12px;
  }

  .req-field-message {
    color: red;
  }
`;

/* eslint-disable react/prefer-stateless-function */
class OutgoingOrderModalComp extends BaseComponent {
  constructor(props) {
    super(props, {
      ...STATE,
      selectedCompany: props?.vehicle?.buyingCompany ?? null,
    });
  }

  componentDidMount() {
    if (this.props.tradeInToCopy?.length && this.props.copyFromInvoice?.id) {
      this.setState({
        selectedTradeInVehicles: this.props.tradeInToCopy.map(v => ({
          value: v?.id,
          label: `${getPropByName(v, 'regplate') ?? ''} ${getPropByName(v, 'brand_name') ?? ''} ${getPropByName(
            v,
            'model_name',
          ) ?? ''} ${getPropByName(v, 'model_info') ?? ''}`,
        })),
      });
    }
    this.props.fetchCompany(this.props.values?.outgoingCompanyId, result => {
      if (result.id) {
        this.props.setValue(result, 'outgoingCompany');
        if (!this.deliveryCompany) this.props.setValue({ company: result }, 'delivery_location');

        const productOptions = {};
        const companyId = result.id;
        const taxRegion = result.properties?.find(p => p?.name?.name === 'company_from_eu')?.value;
        if (companyId) productOptions.companyId = companyId;
        if (taxRegion) productOptions.taxRegion = taxRegion;
        if (this.props.vehicle.vehicle_purpose) productOptions.vehiclePurpose = this.props.vehicle.vehicle_purpose;
        this.props.fetchCompanyProductsIds(companyId, res => {
          if (res?.length) {
            this.props.fetchProducts(productOptions);
          } else {
            this.props.fetchProducts();
          }
        });

        this.getTradeInVehiclesList();
      }
    });
    this.props.vehicle?.buyingCompany &&
      this.props.fetchCompany(this.props.vehicle?.buyingCompany?.id, result => {
        if (result.id) {
          if (!this.selectedCompany) this.props.setValue({ company: result }, 'main_location');
        }
      });

    ['main_location', 'delivery_location'].map(type => this.props.initiateValue(type));
    this.initProducts();

    if (!this.props.vehicle?.regplate) {
      this.setState({ sellWithLicensePlate: true });
    }

    if (this.props.vehicle?.regplate) {
      this.props.setValue('0', 'sell_with_license_plate');
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (!_.isEqual(prevProps?.values?.secondaryProducts, this.props?.values?.secondaryProducts)) {
      this.handleExtraTransportFields();
    }
  }

  initProducts() {
    if (!this.props?.values?.secondaryProducts) {
      this.props.setValue(
        {
          product_1: {
            id: 'product_1',
            costType: '',
            cost: '',
            incl: true,
            description: '',
          },
        },
        'secondaryProducts',
      );
    }
  }

  get locale() {
    return this.props.locale;
  }

  get outgoingCompany() {
    return this.props.values?.outgoingCompany ?? null;
  }

  get deliveryCompany() {
    return this.props.values?.delivery_location?.company ?? null;
  }

  get selectedCompany() {
    return this.props.values?.main_location?.company ?? null;
  }

  get deliveryAddress() {
    return this?.props?.values?.delivery_location?.address ?? null;
  }

  get selectedAddress() {
    return this?.props?.values?.main_location?.address ?? null;
  }

  get secondaryProducts() {
    return this?.props?.values?.secondaryProducts ?? {};
  }

  get isTransportProduct() {
    return !!this?.props?.values?.isTransportProduct;
  }

  get isShowTradeInSection() {
    const isNl = getPropByName(this.outgoingCompany, 'company_from_eu')?.toLowerCase() === 'nl';
    const isIndividual = getPropByName(this.outgoingCompany, 'company_type') === 'individual';
    return isNl && isIndividual;
  }

  get options() {
    const costsEnabled = false;
    const options = [];
    if (costsEnabled) {
      const costOptions = Object.entries(OutgoingCostTypes).map(([key, value]) => ({ label: value, value }));
      options.push(...costOptions);
    }

    for (let product of this.availableProducts) {
      options.push({ label: product.name, value: product.name });
    }

    return options;
  }

  get value() {
    const value = this.options.find(o => o.value == this.props.value);
    return value;
  }

  get secondaryTotalPrice() {
    let totalPrice = 0;
    Object.values(this.secondaryProducts).map(value => (totalPrice += +value.cost));
    return totalPrice;
  }

  getValue(name) {
    const value = this.options.find(o => o.value == name);
    return { id: value?.id, isCounter: value?.isCounter };
  }

  get isChangeableSalesPreferred() {
    return this.props.vehicle?.import == '1';
  }

  get isShowSlideSelectSection() {
    return (
      getPropByName(this.outgoingCompany, 'company_from_eu')?.toLowerCase() == 'outside_eu' ||
      getPropByName(this.outgoingCompany, 'company_from_eu')?.toLowerCase() == 'eu'
    );
  }

  get outgoingCompanyLabel() {
    return getPropByName(this.outgoingCompany, 'name');
  }

  get tradeInVehicleOptions() {
    const options = this.props.filteredVehicles
      ?.filter(vehicle => vehicle?.id != this.props.vehicle?.id)
      ?.map(v => {
        return {
          price: v?.price,
          value: v?.id,
          label: `${v.regplate ?? ''} ${v.brand_name ?? ''} ${v.model_name ?? ''} ${v.model_info ?? ''}`,
          labelCard: `${v.regplate ?? ''} ${v.brand_name ?? ''} ${v.model_name ?? ''}`,
        };
      });
    return options;
  }

  onSelectTradeInvehicle(value) {
    this.setState(prev => ({
      tradeInVehicleValue: value.id,
      selectedTradeInVehicles: [...prev.selectedTradeInVehicles, value],
    }));
  }

  removeTradeInVehicle(value) {
    const tradeInVehicles = this.state.selectedTradeInVehicles?.filter(v => v.value !== value);
    this.setState({ selectedTradeInVehicles: tradeInVehicles });
  }

  renderBpmRefundNotification() {
    if (!this.props.values?.BPM_refund) return;

    if (this.props.values?.BPM_refund == 1 && this.props.values?.BPM_refund_via_indewal != 1) {
      return (
        <VBox>
          <p>
            {this.lbl('vehicle.order.BPM_refund_via')} <strong>“{this.lbl('vehicle.info.finance.client')}”</strong> <br />
            {this.lbl('vehicle.order.BPM_refund_guarantee_notification')}
            <br />
            <p style={{ color: 'red' }}>{this.lbl('vehicle.order.no_zullassung_possible')}</p>
          </p>
        </VBox>
      );
    }
  }

  renderZullassungNotification() {
    if (this.props.values?.zulassung_aanvragen == 1 && this.props.vehicle?.new_from_factory === '1') {
      return <p>{this.lbl('vehicle.order.duitsebrief_notification')}</p>;
    }
  }

  handleExtraTransportFields = () => {
    if (Object.values(this.secondaryProducts).find(p => !!p.isTransport && !!p.incl)) {
      this.props.setValue(true, 'isTransportProduct');
      this.props.setValue('', 'picked_up');
    } else {
      this.resetTransportProduct();
    }
  };

  calculateFinancialAmounts(subject, key) {
    this.props.calculateFinancialAmounts(subject, result => {
      this.props.setValue(
        {
          ...this.secondaryProducts,
          [key]: {
            ...this.secondaryProducts[key],

            priceDetails: result?.product_id ? result : {},
          },
        },
        'secondaryProducts',
      );
    });
  }

  showDefaultTasksConfirmationModal() {
    this.props.setValue(true, 'showDefaultTasksModal');
  }

  closeDefaultTasksConfirmationModal() {
    this.props.setValue(false, 'showDefaultTasksModal');
  }

  onConfirmTasksModalConfirmation(product) {
    this.props.setValue(true, 'applyDefaultTasks');
    this.closeDefaultTasksConfirmationModal();
  }

  onCancelTasksModalConfirmation(product) {
    this.props.setValue(false, 'applyDefaultTasks');
    this.closeDefaultTasksConfirmationModal();
  }

  needToShowDefaultTasksConfirmation(product) {
    return !!product.productTasks.length;
  }

  handleSetProducts = (value, key, prop, productValue) => {
    Object.keys(this.secondaryProducts).map(prod => {
      if (prop === 'editName') {
        this.props.setValue(
          {
            ...this.secondaryProducts,
            [key]: {
              ...this.secondaryProducts[key],
              editedName: value,
            },
          },
          'secondaryProducts',
        );

        return;
      }

      if (this.isProductOption(value) && prop === 'costType') {
        const product = this.availableProducts.find(i => i.name === value);
        const price = product.salesPrice;
        const priceField = 'product_price_incl_vat_per_item';

        this.props.setValue(
          {
            ...this.secondaryProducts,
            [key]: {
              ...this.secondaryProducts[key],
              productId: product.id,
              cost: price,
              costType: value,
              isTransport: product.isTransport,
              description: product.description,
              editedName: null,
            },
          },
          'secondaryProducts',
        );
        if (this.needToShowDefaultTasksConfirmation(product)) {
          this.showDefaultTasksConfirmationModal();
        }
      }

      if (
        prod == key &&
        this.secondaryProducts[key]?.costType !== 'REGISTRATION_NUMBER_PLATE' &&
        value == 'REGISTRATION_NUMBER_PLATE'
      ) {
        this.props.setValue(
          {
            ...this.secondaryProducts,
            [key]: {
              ...this.secondaryProducts[key],
              ['cost']: 15,
            },
          },
          'secondaryProducts',
        );
      }

      if (
        prod == key &&
        this.secondaryProducts[key]?.costType == 'REGISTRATION_NUMBER_PLATE' &&
        value !== 'REGISTRATION_NUMBER_PLATE'
      ) {
        this.props.setValue(
          {
            ...this.secondaryProducts,
            [key]: {
              ...this.secondaryProducts[key],
              [prop]: value,
              ['cost']: '',
            },
          },
          'secondaryProducts',
        );
      }

      if (['cost'].includes(prop)) {
        const product = this.availableProducts.find(i => i.id === productValue?.productId);
        const priceField =
          this.props.values?.tax_type === 'excl.BTW/BPM'
            ? 'product_price_excl_vat_per_item'
            : 'product_price_incl_vat_per_item';
        const fixedPrice = parseFloat(value?.replace(',', '.'));
        this.props.setValue(
          {
            ...this.secondaryProducts,
            [key]: {
              ...this.secondaryProducts[key],
              [prop]: value,
            },
          },
          'secondaryProducts',
        );
        this._t = this.timeout(
          () =>
            this.props.setValue(
              {
                ...this.secondaryProducts,
                [key]: {
                  ...this.secondaryProducts[key],
                  [prop]: fixPriceFormat(fixedPrice),
                },
              },
              'secondaryProducts',
            ),
          2500,
          this._t,
        );
      }
      if (['description'].includes(prop)) {
        this.props.setValue(
          {
            ...this.secondaryProducts,
            [key]: {
              ...this.secondaryProducts[key],
              [prop]: value,
            },
          },
          'secondaryProducts',
        );
      }
    });
  };

  isProductOption(key) {
    return true;
    // return !Object.keys(OutgoingCostTypes).includes(key);
  }

  addProduct() {
    const length = Object.keys(this.secondaryProducts).length;

    this.props.setValue(
      {
        ...this.secondaryProducts,
        [`product_${length + 1}`]: {
          id: `product_${length + 1}`,
          costType: '',
          cost: '',
          incl: true,
          description: '',
        },
      },
      'secondaryProducts',
    );
  }

  get vehiclePriceField() {
    const { vehicle } = this.props;

    if (vehicle?.tax_type == 'BTW') return 'financial_price_incl_vat_bpm';

    if (vehicle?.tax_type == 'marge') return 'financial_price_marge_incl_bpm';

    return null;
  }

  toggleDisableSave = value => {
    this.setState({ disableSave: value });
  };

  isCalculating() {
    return !!this.props.calcWorks || !!this.state.disableSave;
  }

  save() {
    let salesAmounts = {
      [this.vehiclePriceField]: this.props.values.main_cost,
    };
    let costs = [];
    const products = [];

    let vehicleProperties = [
      { propertyName: 'sell_with_license_plate', propertyValue: this.props.values?.sell_with_license_plate || null },
      {
        propertyName: 'fix_damages',
        propertyValue: this.props.values?.fix_damages || null,
      },
    ];

    if (this.props.values?.fix_damages == '1' && this.props.values?.fixed_damages_details) {
      vehicleProperties.push({
        propertyName: 'fix_damages_details',
        propertyValue: this.props.values?.fixed_damages_details,
      });
    }

    if (this.props.values?.bpm_guarantee_sum) {
      vehicleProperties.push({
        propertyName: 'bpm_guarantee_sum',
        propertyValue: this.props.values?.bpm_guarantee_sum,
      });
    }

    if (this.props.values?.BPM_refund == '1' && this.props.values?.BPM_refund_via_indewal == '1') {
      vehicleProperties.push({
        propertyName: 'BPM_refund_via_indewal',
        propertyValue: '1',
      });
    }

    if (this.props.values?.zulassung_aanvragen == '1') {
      vehicleProperties.push({
        propertyName: 'zulassung_aanvragen',
        propertyValue: '1',
      });
    }

    if (this.props.values?.BPM_refund == 1) {
      vehicleProperties.push({
        propertyName: 'BPM_refund',
        propertyValue: '1',
      });
    }

    if (this.props.values?.BPM_refund == 1 && this.props.values?.BPM_refund_via_indewal != 1) {
      vehicleProperties.push({
        propertyName: 'outgoing_bpm_refund_deposit',
        propertyValue: '1',
      });
    }

    if (this.props.values?.picked_up) {
      vehicleProperties.push({
        propertyName: 'pickedUp',
        propertyValue: this.props.values?.picked_up,
      });
    }
    // From company and locations props
    if (this.props.values?.main_location?.address?.postcode) {
      vehicleProperties.push({
        propertyName: 'transport_from_address_postcode',
        propertyValue: this.props.values?.main_location?.address?.postcode,
      });
      vehicleProperties.push({
        propertyName: 'transport_outgoing_from_address_id',
        propertyValue: this.props.values?.main_location?.address?.id,
      });
    }
    if (this.props.values?.main_location?.company?.id) {
      vehicleProperties.push({
        propertyName: 'transport_outgoing_from_company_id',
        propertyValue: this.props.values?.main_location?.company?.id,
      });
    }
    if (getPropByName(this.props.values.main_location?.company, 'name')) {
      vehicleProperties.push({
        propertyName: 'transport_outgoing_from_company_name',
        propertyValue: getPropByName(this.props.values.main_location?.company, 'name'),
      });
    }

    // To company and location props
    if (this.props.values?.delivery_location?.address?.postcode) {
      vehicleProperties.push({
        propertyName: 'transport_to_address_postcode',
        propertyValue: this.props.values?.delivery_location?.address?.postcode,
      });
      vehicleProperties.push({
        propertyName: 'transport_outgoing_to_address_id',
        propertyValue: this.props.values?.delivery_location?.address?.id,
      });
    }
    if (this.props.values.delivery_location?.company?.id) {
      vehicleProperties.push({
        propertyName: 'transport_outgoing_to_company_id',
        propertyValue: this.props.values.delivery_location?.company?.id,
      });
    }
    if (this.props.values.delivery_location?.company?.id) {
      vehicleProperties.push({
        propertyName: 'transport_outgoing_to_company_id',
        propertyValue: this.props.values.delivery_location?.company?.id,
      });
    }
    if (getPropByName(this.props.values.delivery_location?.company, 'name')) {
      vehicleProperties.push({
        propertyName: 'transport_outgoing_to_company_name',
        propertyValue: getPropByName(this.props.values.delivery_location?.company, 'name'),
      });
    }

    vehicleProperties.push({
      propertyName: 'transport_outgoing_is_nl',
      propertyValue:
        getPropByName(this.props.values.delivery_location?.company, 'company_from_eu') == 'NL' &&
        getPropByName(this.props.values.main_location?.company, 'company_from_eu') == 'NL'
          ? '1'
          : '0',
    });

    vehicleProperties.push({
      propertyName: 'transport_outgoing_requested',
      propertyValue: '1',
    });
    vehicleProperties.push({
      propertyName: 'direction',
      propertyValue: 'outgoing',
    });
    vehicleProperties.push({
      propertyName: 'transport_outgoing_filled_date',
      propertyValue: new Date().toISOString(),
    });

    Object.entries(this.secondaryProducts).forEach(([key, val]) => {
      if (!val['incl']) {
        return;
      }
      let dtoObj = null;
      const isProduct = this.isProductOption(val['costType']);
      if (isProduct) {
        dtoObj = this.mapProductToDtoObj(val);
      } else {
        dtoObj = this.mapCostToDtoObj(val);
      }

      if (isProduct && dtoObj) products.push(dtoObj);
      if (!isProduct && dtoObj) costs.push(dtoObj);
    });

    let properties = {
      outgoingCompanyId: this.props.values.outgoingCompanyId,
      outgoingUserId: this.props.values.client,
      salesAmounts,
      costs,
      products,
      properties: vehicleProperties,
      startLocationCompanyId: this.props.values.main_location?.address?.id
        ? this.props.values.main_location?.company?.id
        : null,
      startLocationId: this.props.values.main_location?.address?.id,
      deliveryLocationCompanyId:
        this.props.values.delivery_location?.address?.id || this.props.values.delivery_location?.address
          ? this.props.values.delivery_location?.company?.id
          : null,
      deliveryLocationId: this.props.values.delivery_location?.address?.id || this.props.values.delivery_location?.address,
      financialContactId: this.props.values?.includeFinancialContact === '1' ? this.props.values?.financial_contact : '',
      emailContactId: this.props.values?.includeEmailContact === '1' ? this.props.values?.email_contact : '',
      emailTo: this.props.values?.includeManual === '1' ? this.props.values?.send_to_email : '',
      // transport: this.props.values?.transport,
      // releaseBeforeOutgoingTransport: this.props.values?.release_before_outgoing_transport,
      contactId: this.props.values.seller,
      pickedUp: this.props.values?.picked_up,
      tradeInVehicleIds: this.state.selectedTradeInVehicles?.map(v => v.value),
    };

    if (this.props.values?.comment) {
      properties.invoiceAddittionalLines = [this.props.values.comment];
    }

    this.props.addToOrder(
      this.props.vehicle?.id,
      properties,
      { applyDefaultTasks: this.props.values['applyDefaultTasks'] },
      res => {
        this.props.bulkAction && this.props.onClose();
        this.props.setSearchString('');
        console.log(res, 'result');
      },
    );
    !this.props.bulkAction && this.props.onClose();
  }

  mapCostToDtoObj(val) {
    let priceKey = 'cost_price_incl_vat';
    let costObj = {
      costType: val['costType'],
      [priceKey]: val['cost'],
    };
    if (costObj.costType == 'TRANSPORT') {
      return costObj;
    }
    if (!costObj.costType || !costObj[priceKey]) return null;
    return costObj;
  }

  mapProductToDtoObj(val) {
    if (!val['productId']) return null;

    let priceKey = 'product_price_incl_vat_per_item';
    let productObj = {
      productId: val['productId'],
      [priceKey]: val['cost'],
      isTransport: val['isTransport'] ? '1' : null,
      description: val['description'],
    };
    if (val.editedName) productObj.description = val.editedName;
    return productObj;
  }
  reset() {
    this.setState({ ...STATE });
  }

  resetTransportProduct() {
    ['main_location', 'delivery_location'].map(type => this.props.setValue('', type));
    this.props.setValue(false, 'isTransportProduct');
    this.props.setValue({ company: this.selectedCompany, address: null }, 'main_location');
    this.props.setValue({ company: this.deliveryCompany, address: null }, 'delivery_location');
  }

  handleSetAddress = a => {
    return this.props.setValue({ company: this.selectedCompany, address: a }, 'main_location');
  };

  handleSetDeliveryAddress = a => {
    return this.props.setValue({ company: this.deliveryCompany, address: a }, 'delivery_location');
  };

  onSetLocation = (company, address) => {
    this.setState({ showLocationChange: false });

    return this.props.setValue({ company: company, address: address }, 'main_location');
  };

  onSetDeliveryLocation = (company, address) => {
    this.setState({ showDeliveryLocationChange: false });
    return this.props.setValue({ company: company, address: address }, 'delivery_location');
  };

  onIsIncludeMainProduct() {
    if (this.state.inclMainProd) {
      this.props.setValue('', 'main_cost');
    }
    this.setState({ inclMainProd: !this.state.inclMainProd });
  }

  onIsIncludeSecondaryProduct(value, key) {
    Object.keys(this.secondaryProducts).map(prod => {
      // if (prod == key && this.secondaryProducts[key]?.costType == 'TRANSPORT') {
      //   this.resetTransportProduct();
      // }
      console.log({ value, key, prod });
      if (prod == key) {
        this.props.setValue(
          {
            ...this.secondaryProducts,
            [key]: !!this.secondaryProducts[key].incl
              ? {
                  ...this.secondaryProducts[key],
                  incl: false,
                }
              : {
                  ...this.secondaryProducts[key],
                  incl: true,
                },
          },
          'secondaryProducts',
        );
      }
    });
  }

  showPaymentConditionModal() {
    return this.outgoingCompany && !getPropByName(this.outgoingCompany, 'vindat_paymentcondition') && !this.state.closeModal;
  }

  applyDisabled() {
    return this.isTransportProduct
      ? !this.selectedAddress?.id || !this.deliveryAddress?.id || !this.vehiclePriceField || !this.props.values.main_cost
      : !this.vehiclePriceField || !this.props.values.main_cost || !this.props.values.picked_up;
  }

  get availableProducts() {
    // TODO filter based on direction, purpose
    const availableProducts = this.props.availableProducts?.filter(
      p => p.status != PRODUCT_STATUS.DEACTIVE && p.status != PRODUCT_STATUS.DELETED,
    );
    return availableProducts;
  }

  get total() {
    return ((Number(this.props.values?.main_cost) || 0) + (Number(this.secondaryTotalPrice) || 0)).toFixed(2);
  }

  getTradeInVehiclesList() {
    this.props.getTradeInVehiclesList({
      companyId: this.props?.values?.outgoingCompanyId,
      isBulkAction: this.props.bulkAction ?? false,
    });
  }

  render() {
    const vehicle = this.props.vehicle;
    const tasks = [
      'task_attach_parts',
      'task_desticker',
      'task_polish_exterior',
      'task_interior_polish',
      'task_interior_repair',
      'task_int_ext_polish',
      'task_restyle',
      'task_spot_repair',
      'task_spray',
      'task_window_repair',
      'task_repair',
    ];
    const hasTask1 = tasks.some(task => vehicle[task] === '1');
    const hasTask2 = tasks.some(task => vehicle[task] === '2');
    const hasTask3 = tasks.some(task => vehicle[task] === '3');

    // !this.props.vehicle.tax_type ? <Warnings message={'Outgoing order can not be created because tax_type of vehicle is not set'} hideWarning={this.props.reset}/> :
    return (
      <Container>
        {this.props.values['showDefaultTasksModal'] && (
          <ProductDefaultTasksModalConfirmation
            onConfirm={this.onConfirmTasksModalConfirmation.bind(this)}
            onCancel={this.onCancelTasksModalConfirmation.bind(this)}
          />
        )}
        <ModalComponent
          onClose={this.props.reset}
          title={this.lblStr('vehicle.order.add_outgoing_order') + ' voor: ' + this?.outgoingCompanyLabel}
          size="xl"
        >
          <div className="row">
            <div className="col-lg-8 col-12">
              <div>
                <div style={{ border: '1px solid #dbdcdc', padding: '10px 10px 20px 10px' }}>
                  <div style={{ backgroundColor: '#EEF2F7', padding: '0px 25px 20px 5px', margin: '-10px -10px 0px -10px' }}>
                    <div class="row">
                      <div class="col-lg-12 col-md-12 col-sm-12">
                        {['tax_type'].map(type => (
                          <VehicleCreateOrderField vehicle={this.props.vehicle} key={type} type={type} />
                        ))}
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-lg-12 col-md-12 col-sm-12">
                        {['main_cost'].map(type => (
                          <VehicleCreateOrderField
                            isDisabledMainProd={!this.state.inclMainProd}
                            secondaryTotalPrice={this.secondaryTotalPrice}
                            vehicle={this.props.vehicle}
                            saveDisable={this.toggleDisableSave}
                            workCalc={this.props.workCalc || this.isCalculating()}
                            key={type}
                            type={type}
                          />
                        ))}
                      </div>
                    </div>
                  </div>
                  {this.props.workProducts ? (
                    <LoadingField />
                  ) : (
                    <div class="row" style={{ marginTop: '20px' }}>
                      {/* <div>{this.lbl('product.addproduct')}:</div> */}

                      {Object.entries(this.secondaryProducts).map(([key, value]) => (
                        <>
                          <div className={styles.inputPrice}> Bijverkopen:</div>
                          <div class="row">
                            <div class="col-lg-8 col-12">
                              <div className={styles.containerSecondaryProducts}>
                                <div className={cn(styles.productContainer, styles.container)} key={value.id}>
                                  <div className={styles.dropdownFlex}>
                                    <div className="field label">
                                      {/* <CheckboxComponent
                                      checked={value.incl}
                                      onChange={evt => this.onIsIncludeSecondaryProduct(evt, key)}
                                    /> */}
                                    </div>
                                    <EditableSearchSelect
                                      className="medium-dropdown"
                                      options={value.incl ? this.options : []}
                                      placeholder={'Select...'}
                                      value={value.costType && { label: value.costType }}
                                      onChange={evt =>
                                        this.handleSetProducts(evt.value, key, 'costType', this.getValue(evt?.value))
                                      }
                                      onEdit={evt => this.handleSetProducts(evt.value, key, 'editName')}
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div class="col-lg-4 col-12">
                              <div className={styles.inputPrice}>
                                <div className={styles.decoratorLabel}>€</div>

                                <input
                                  className="form-control"
                                  disabled={!value.incl}
                                  name={value.id}
                                  value={limitToTwoDecimalPlaces(value.cost)}
                                  onChange={evt => this.handleSetProducts(evt.target.value, key, 'cost')}
                                />
                              </div>
                            </div>

                            {value.costType && (
                              <div className="mt-2 mb-2">
                                <label className="form-label">{this.lbl('product.create.description')}</label>
                                <textarea
                                  className="form-control"
                                  disabled={!value.incl}
                                  name={value.id}
                                  value={value.description}
                                  onChange={evt => this.handleSetProducts(evt.target.value, key, 'description')}
                                />
                              </div>
                            )}
                          </div>
                        </>
                      ))}

                      <div className={styles.containerNewButton}>
                        <ButtonComponent size={'btn-sm'} style={'ButtonSoftPrimary'} onClick={() => this.addProduct()}>
                          {this.lbl('product.create.title')}
                        </ButtonComponent>
                      </div>
                    </div>
                  )}
                </div>
                <div class="row">
                  <label className="form-label">{this.lbl('vehicle.order.seller')}</label>
                  {this.outgoingCompany &&
                    ['seller'].map(type => (
                      <VehicleCreateOrderField
                        outgoingCompany={this.outgoingCompany}
                        loggedInuser={this.props.loggedInUserId}
                        vehicle={this.props.vehicle}
                        key={type}
                        type={type}
                      />
                    ))}
                </div>

                <div class="row">
                  {this.state.sellWithLicensePlate && (
                    <div>
                      <label className={cn(!this.props.values.sell_with_license_plate && 'req-field-message', 'form-label')}>
                        {this.lbl('vehicle.order.sell_with_license_plate')}
                        {!this.props.values.sell_with_license_plate && <span style={{ marginLeft: '5px' }}>*</span>}
                      </label>
                      {['sell_with_license_plate'].map(type => (
                        <VehicleCreateOrderField key={type} type={type} />
                      ))}
                    </div>
                  )}

                  <div>
                    <label className={cn(!this.props.values.fix_damages && 'req-field-message', 'form-label')}>
                      {this.lbl('vehicle.order.fix_damages')}
                      {!this.props.values.fix_damages && <span style={{ marginLeft: '5px' }}>*</span>}
                    </label>
                    {['fix_damages'].map(type => (
                      <VehicleCreateOrderField key={type} type={type} />
                    ))}
                  </div>

                  {this.props.values.fix_damages === '0' && (hasTask1 || hasTask2 | hasTask3) ? (
                    <div>
                      <label className="form-label">{this.lbl('outgoingorder.modal.has_open_task')}</label>
                      <ul>
                        {this.props.vehicle.task_attach_parts === '1' && (
                          <li>{this.lbl('vehicle.property.task_attach_parts')}</li>
                        )}
                        {this.props.vehicle.task_desticker === '1' && <li>{this.lbl('vehicle.property.task_desticker')}</li>}
                        {this.props.vehicle.task_polish_exterior === '1' && (
                          <li>{this.lbl('vehicle.property.task_polish_exterior')}</li>
                        )}
                        {this.props.vehicle.task_interior_polish === '1' && (
                          <li>{this.lbl('vehicle.property.task_interior_polish')}</li>
                        )}
                        {this.props.vehicle.task_interior_repair === '1' && (
                          <li>{this.lbl('vehicle.property.task_interior_repair')}</li>
                        )}
                        {this.props.vehicle.task_int_ext_polish === '1' && (
                          <li>{this.lbl('vehicle.property.task_int_ext_polish')}</li>
                        )}
                        {this.props.vehicle.task_restyle === '1' && <li>{this.lbl('vehicle.property.task_restyle')}</li>}
                        {this.props.vehicle.task_spot_repair === '1' && (
                          <li>{this.lbl('vehicle.property.task_spot_repair')}</li>
                        )}
                        {this.props.vehicle.task_spray === '1' && <li>{this.lbl('vehicle.propery.task_spray')}</li>}
                        {this.props.vehicle.task_window_repair === '1' && (
                          <li>{this.lbl('vehicle.property.task_window_repair')}</li>
                        )}
                        {this.props.vehicle.task_repair === '1' && <li>{this.lbl('vehicle.property.task_repair')}</li>}
                        {this.props.vehicle.task_attach_parts === '2' && (
                          <li>{this.lbl('vehicle.property.task_attach_parts')}</li>
                        )}
                        {this.props.vehicle.task_desticker === '2' && <li>{this.lbl('vehicle.property.task_desticker')}</li>}
                        {this.props.vehicle.task_polish_exterior === '2' && (
                          <li>{this.lbl('vehicle.property.task_polish_exterior')}</li>
                        )}
                        {this.props.vehicle.task_interior_polish === '2' && (
                          <li>{this.lbl('vehicle.property.task_interior_polish')}</li>
                        )}
                        {this.props.vehicle.task_interior_repair === '2' && (
                          <li>{this.lbl('vehicle.property.task_interior_repair')}</li>
                        )}
                        {this.props.vehicle.task_int_ext_polish === '2' && (
                          <li>{this.lbl('vehicle.property.task_int_ext_polish')}</li>
                        )}
                        {this.props.vehicle.task_restyle === '2' && <li>{this.lbl('vehicle.property.task_restyle')}</li>}
                        {this.props.vehicle.task_spot_repair === '2' && (
                          <li>{this.lbl('vehicle.property.task_spot_repair')}</li>
                        )}
                        {this.props.vehicle.task_spray === '2' && <li>{this.lbl('vehicle.propery.task_spray')}</li>}
                        {this.props.vehicle.task_window_repair === '2' && (
                          <li>{this.lbl('vehicle.property.task_window_repair')}</li>
                        )}
                        {this.props.vehicle.task_repair === '2' && <li>{this.lbl('vehicle.property.task_repair')}</li>}
                        {this.props.vehicle.task_attach_parts === '3' && (
                          <li>{this.lbl('vehicle.property.task_attach_parts')}</li>
                        )}
                        {this.props.vehicle.task_desticker === '3' && <li>{this.lbl('vehicle.property.task_desticker')}</li>}
                        {this.props.vehicle.task_polish_exterior === '3' && (
                          <li>{this.lbl('vehicle.property.task_polish_exterior')}</li>
                        )}
                        {this.props.vehicle.task_interior_polish === '3' && (
                          <li>{this.lbl('vehicle.property.task_interior_polish')}</li>
                        )}
                        {this.props.vehicle.task_interior_repair === '3' && (
                          <li>{this.lbl('vehicle.property.task_interior_repair')}</li>
                        )}
                        {this.props.vehicle.task_int_ext_polish === '3' && (
                          <li>{this.lbl('vehicle.property.task_int_ext_polish')}</li>
                        )}
                        {this.props.vehicle.task_restyle === '3' && <li>{this.lbl('vehicle.property.task_restyle')}</li>}
                        {this.props.vehicle.task_spot_repair === '3' && (
                          <li>{this.lbl('vehicle.property.task_spot_repair')}</li>
                        )}
                        {this.props.vehicle.task_spray === '3' && <li>{this.lbl('vehicle.propery.task_spray')}</li>}
                        {this.props.vehicle.task_window_repair === '3' && (
                          <li>{this.lbl('vehicle.property.task_window_repair')}</li>
                        )}
                        {this.props.vehicle.task_repair === '3' && <li>{this.lbl('vehicle.property.task_repair')}</li>}
                      </ul>
                    </div>
                  ) : null}
                  {this.props.values.fix_damages === '1' && (
                    <div>
                      <label className="form-label">{this.lbl('vehicle.order.details.damage')}</label>
                      {['fixed_damages_details'].map(type => (
                        <VehicleCreateOrderField key={type} type={type} />
                      ))}
                    </div>
                  )}
                  {this.isShowSlideSelectSection && (
                    <VehicleCreateOrderField key="bpm_guarantee_sum" type="bpm_guarantee_sum" />
                  )}
                </div>

                <div className="row">
                  <VehicleCreateOrderField key="comment" type="comment" />
                </div>

                {!this.isTransportProduct && (
                  <div>
                    <label className="form-label">{this.lbl('vehicle.order.picked_up')}</label>
                    {['picked_up'].map(type => (
                      <VehicleCreateOrderField key={type} type={type} />
                    ))}
                  </div>
                )}
                <div>
                  {this.isShowTradeInSection && (
                    <div>
                      <label className="form-label">{this.lbl('vehicle.order.add_to_trade_in')}</label>

                      <div>
                        <SearchSelect
                          maxHeight="100px"
                          isLoading={this.props.workVehicles}
                          options={this.tradeInVehicleOptions}
                          value={this.state.tradeInVehicleValue?.id}
                          onChange={this.onSelectTradeInvehicle.bind(this)}
                          onMenuOpen={this.getTradeInVehiclesList.bind(this)}
                          isOptionDisabled={option => {
                            return !!this.state.selectedTradeInVehicles?.find(v => v?.value == option.value)?.value;
                          }}
                        />

                        <div className="mt-2 mb-2">
                          <VehicleCreateModals
                            tradeInVehicle
                            defaultCreditor={this.props.values.outgoingCompanyId}
                            defaultCreditorUser={this.props.values.client}
                          />
                        </div>
                      </div>
                      {this.state.selectedTradeInVehicles?.map(v => {
                        return (
                          <div key={v.value} className="d-flex justify-content-between align-items-center">
                            <CheckboxComponent checked label={v.label} />
                            <div
                              style={{ color: '#d50046', fontSize: '20px', cursor: 'pointer' }}
                              onClick={() => {
                                this.removeTradeInVehicle(v.value);
                              }}
                            >
                              <CircleTimes />
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  )}

                  {this.showPaymentConditionModal() && (
                    <InvoicePaymentConditionModal
                      onReset={this.props.reset}
                      onClose={() => this.setState({ closeModal: true })}
                      outgoingCompany={this.outgoingCompany}
                    />
                  )}
                </div>
                {this.isTransportProduct && (
                  <div className="mb-2">
                    <label className="form-label">{this.lbl('vehicle.order.select_location')}</label>
                    <HBox left flexWrap flip={window.innerWidth < 768} style={{ gap: 10 }} className={'address-block'}>
                      {this.selectedCompany?.addresses?.map(address => (
                        <Address
                          key={`${address?.id}`}
                          onClick={() => address.country && this.handleSetAddress(address)}
                          isActive={this.selectedAddress?.id === address?.id}
                        >
                          <VBox left>
                            <HBox vCenter>
                              <h6 className="name">{this.lbl(`address.type.${address?.type?.name || 'other'}`)}</h6>
                              <CheckboxComponent
                                disabled={!address.country}
                                checked={this.selectedAddress?.id === address?.id}
                              />
                            </HBox>
                            <VBox className="address" left>
                              <div>{address?.addressLine1}</div>
                              <div>
                                {address?.postcode} {address?.city}
                              </div>
                              <div>{translateCountry(address.country?.name, this.locale)}</div>
                              {!address.country && <div className="req-field-message">{'Country is required *'}</div>}
                            </VBox>
                          </VBox>
                        </Address>
                      ))}
                      {this.state.showLocationChange && (
                        <ChangeLocationModal
                          invoiceData="true"
                          company={this.props.vehicle?.locationCompany}
                          address={this.props.vehicle?.locationAddress}
                          onClose={() => this.setState({ showLocationChange: false })}
                          onConfirm={this.onSetLocation}
                        />
                      )}
                    </HBox>
                    <div className={styles.locationContainer}>
                      <ButtonComponent style="ButtonSoftPrimary" onClick={this.setStateFn({ showLocationChange: true })}>
                        {this.lbl('vehicle.location.other_transport_location')}
                      </ButtonComponent>
                    </div>

                    <label className="form-label">{this.lbl('vehicle.order.delivery_location')}</label>
                    <HBox left flexWrap flip={window.innerWidth < 768} style={{ gap: 10 }} className={'address-block'}>
                      {this.deliveryCompany?.addresses?.map(address => (
                        <Address
                          key={`${address?.id}`}
                          onClick={() => address.country && this.handleSetDeliveryAddress(address)}
                          isActive={this.deliveryAddress?.id === address?.id}
                        >
                          <VBox left>
                            <HBox vCenter>
                              <h6 className="name">{this.lbl(`address.type.${address?.type?.name || 'other'}`)}</h6>
                              <CheckboxComponent
                                disabled={!address.country}
                                checked={this.deliveryAddress?.id === address?.id}
                              />
                            </HBox>
                            <VBox className="address" left>
                              <div>{address?.addressLine1}</div>
                              <div>
                                {address?.postcode} {address?.city}
                              </div>
                              <div>{translateCountry(address.country?.name, this.locale)}</div>
                              {!address.country && <div className="req-field-message">{'Country is required *'}</div>}
                            </VBox>
                          </VBox>
                        </Address>
                      ))}
                      <Address
                        key={`unknown`}
                        unknown={true}
                        className="unknown-address"
                        onClick={() => this.handleSetDeliveryAddress('unknown')}
                        isActive={this.deliveryAddress === 'unknown'}
                      >
                        <VBox left>
                          <HBox vCenter>
                            <h6 className="name">{this.lbl(`address.type.transport_location`)}</h6>
                            <CheckboxComponent checked={this.deliveryAddress === 'unknown'} />
                          </HBox>
                          <VBox className="address" left>
                            <div></div>
                            <div>unknown</div>
                          </VBox>
                        </VBox>
                      </Address>
                      {this.state.showDeliveryLocationChange && (
                        <ChangeLocationModal
                          invoiceData="true"
                          company={this.deliveryCompany}
                          address={this.deliveryAddress}
                          onClose={() => this.setState({ showDeliveryLocationChange: false })}
                          onConfirm={this.onSetDeliveryLocation}
                        />
                      )}
                    </HBox>
                    <div className={styles.locationContainer}>
                      <ButtonComponent
                        style="ButtonSoftPrimary"
                        onClick={this.setStateFn({ showDeliveryLocationChange: true })}
                      >
                        {this.lbl('vehicle.location.other_transport_location')}
                      </ButtonComponent>
                    </div>
                  </div>
                )}
              </div>
            </div>
            <div class="col-lg-4 d-none d-lg-block" style={{ backgroundColor: '#EEF1EF' }}>
              <OutgoingOrderVehicleCard vehicle={this.props.vehicle} products={Object.entries(this.secondaryProducts)} />

              <div>
                <div>
                  {['total_price'].map(type => (
                    <VehicleCreateOrderField
                      secondaryTotalPrice={this.secondaryTotalPrice}
                      vehicle={this.props.vehicle}
                      key={type}
                      type={type}
                    />
                  ))}
                </div>
              </div>
              {this.state.selectedTradeInVehicles?.length > 0 && (
                <OutgoingOrderTradeInCard selectedTradeInVehicles={this.state.selectedTradeInVehicles} total={this.total} />
              )}
            </div>
          </div>

          <div className={styles.buttonContainer}>
            <ButtonComponent style="ButtonSoftPrimary" onClick={this.props.handlePrev}>
              Back
            </ButtonComponent>

            <div className={styles.rowButtonsWrapper}>
              <ButtonComponent style={'ButtonSoftDelete'} onClick={this.props.reset}>
                {this.lbl(`cancel`)}
              </ButtonComponent>
              <ButtonComponent
                style={'ButtonSoftEdit'}
                disabled={this.applyDisabled()}
                type="submit"
                onClick={() => this.save()}
              >
                {this.lbl(`confirm`)}{' '}
              </ButtonComponent>
            </div>
          </div>
        </ModalComponent>
      </Container>
    );
  }
}

OutgoingOrderModalComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
  address: PropTypes.object,
  vehicle: PropTypes.object,
  reset: PropTypes.func,
  onClose: PropTypes.func,
  onConfirm: PropTypes.func,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    locale: makeSelectLocale(),
    loggedInUserId: selectUserId(),
    values: selectNewOrder(),
    availableProducts: selectProducts(),
    workProducts: selectWorks([REQUEST_PRODUCTS, REQUEST_COMPANY_PRODUCTS_IDS]),
    workVehicles: selectWorks([REQUEST_VEHICLES, `${REQUEST_VEHICLES + '_bulkAction'}`]),
    workCalc: selectWork(REQUEST_AMOUNTS_CALCULATIONS),
    filteredVehicles: selectVehicles(),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    fetchUser(id, callback) {
      dispatch(fetchUser(id, callback));
    },
    fetchCompany(id, callback) {
      dispatch(fetchCompany(id, callback));
    },
    initiateValue(type) {
      dispatch(initiateNewOrderValue(type));
    },
    setValue(value, name = null) {
      name = name ?? ownProps.type;
      dispatch(setNewOrderValue(name, value));
    },
    addToOrder(id, properties, options, callback) {
      dispatch(addVehicleToOutgoingOrder(id, properties, options, callback));
    },
    setSearchString(text) {
      dispatch(applyTransportOrderFilters());
    },
    fetchProducts(options) {
      dispatch(fetchProducts(options, null, 0, 10000));
    },
    fetchCompanyProductsIds(companyId, callback) {
      dispatch(fetchCompanyProductsIds(companyId, callback));
    },
    getTradeInVehiclesList(options) {
      dispatch(getTradeInVehiclesList(options));
    },
    calculateFinancialAmounts(subject, callback) {
      if (!+subject?.vatCode && +subject?.vatCode != 0) {
        subject.vatCode = DEFAULT_VAT_CODE;
      }

      dispatch(calculateFinancialAmounts(subject, callback));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const OutgoingOrderModal = compose(withConnect, withRouter, injectIntl)(OutgoingOrderModalComp);
